import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { NotificationManager } from "react-notifications";
import { TurnosProduccionApi } from "../../api/TurnosProduccionApi";
import LoadMask from "../../../../../../../Utils/LoadMask/LoadMask";
import { getErrorFromResponse } from "../../../../../../../../../utility/utils";
import { FormInicioProd } from "./components/FormInicioProd";
import { TabsOrdenes } from "./components/TabsOrdenes";
import { BultosSkimApi } from "../../../../api/BultosSkimApi";
import { RenderKilogramo } from "../../../../../../../Utils/renderField/renderReadField";
import { ProduccionV2Api } from "../../../../../api/ProduccionV2Api";
import { DecisionSwal } from "../../../../../../../Utils/Utils/DecisionSwal";
import { CorrelativoTancadas } from "../../../../components/CorrelativoTancadas/CorrelativoTancadas";
import { useCorrelativoTancadas } from "../../../../../hooks/useCorrelativoTancadas";

export const TurnoActualTab = ({
    tabActiva,
    nombreUsuario,
    navigateToTancadas,
    tab2,
    handleChangeTab2,
    navigateToPaletizaciones,
    navigateToCierreTurno,
}) => {
    const { control, watch } = useForm();

    const correlativo = useCorrelativoTancadas();

    const { getTurnoActual, cargando: cargandoTurnoActual } = ProduccionV2Api();

    const { getTotalesBultosSkim, cargando: cargandoRestanteSkim } =
        BultosSkimApi();

    const [turnoActual, setTurnoActual] = useState(null);
    const [paletizacionCerrada, setPaletizacionCerrada] = useState(false);

    const GetTurnoActual = async () => {
        try {
            const response = await getTurnoActual();
            if (response.id) setTurnoActual(response);
            else setTurnoActual(null);

            setPaletizacionCerrada(response.paletizacion_cerrada);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el turno actual",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setTurnoActual(null);
            setPaletizacionCerrada(false);
        }
    };

    const [restanteSkim, setRestanteSkim] = useState(0);

    const GetRestanteSkim = async () => {
        try {
            const response = await getTotalesBultosSkim();
            setRestanteSkim(response.kg_humedos_restantes);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el restante de skim",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setRestanteSkim(0);
        }
    };

    // la pestaña queda montada al cambiar de tab, así que se recarga al volver a
    // ella: si mientras tanto se reabrió un turno, aquí ya hay uno activo
    useEffect(() => {
        if (tabActiva !== "TURNO_ACTUAL") return;

        GetTurnoActual();
        GetRestanteSkim();
    }, [tabActiva]);

    const IrACierreTurno = () => {
        if (!paletizacionCerrada) {
            DecisionSwal(
                "La paletización no ha sido cerrada.",
                "Ir a paletización",
                "Cancelar",
                () => navigateToPaletizaciones(),
            );
        } else {
            navigateToCierreTurno();
        }
    };

    // sin correlativo configurado no se puede trabajar el turno, porque las
    // tancadas quedarían sin número: el tab muestra solo la configuración
    if (!correlativo.configurado) {
        return (
            <div className="turnos-produccion__tab-wrapper">
                <LoadMask loading={correlativo.cargando} blur>
                    <CardEmpty noShadow>
                        <CorrelativoTancadas hook={correlativo} />
                    </CardEmpty>
                </LoadMask>
            </div>
        );
    }

    return (
        <div className="turnos-produccion__tab-wrapper">
            <LoadMask
                loading={cargandoTurnoActual || cargandoRestanteSkim}
                blur
            >
                <CardEmpty noShadow>
                    <FormInicioProd
                        nombreUsuario={nombreUsuario}
                        turnoActual={turnoActual}
                        GetTurnoActual={GetTurnoActual}
                    />

                    <div
                        style={{
                            borderTop: "1px solid #ccc",
                            paddingTop: "20px",
                        }}
                    />

                    <CorrelativoTancadas hook={correlativo} />

                    <div
                        style={{
                            borderTop: "1px solid #ccc",
                            marginTop: "20px",
                        }}
                    />

                    <TabsOrdenes
                        turnoActual={turnoActual}
                        navigateToTancadas={navigateToTancadas}
                        tab2={tab2}
                        handleChangeTab2={handleChangeTab2}
                    />

                    <div className="d-flex justify-content-between my-4 gap-1rem">
                        {turnoActual && (
                            <button
                                className="btn btn-secondary"
                                onClick={() => IrACierreTurno()}
                            >
                                Cerrar turno
                            </button>
                        )}

                        <div className="d-flex gap-1rem ml-auto">
                            <Link to={`/produccion-v2/bultos-skim`}>
                                <button className="btn btn-outline-dark">
                                    Preparación de Skim (
                                    <RenderKilogramo
                                        value={restanteSkim}
                                        decimals={3}
                                    />
                                    )
                                </button>
                            </Link>
                            {turnoActual && (
                                <Link
                                    to={`/produccion-v2/produccion-reportada`}
                                >
                                    <button className="btn btn-primary">
                                        Reportar producción
                                    </button>
                                </Link>
                            )}
                        </div>
                    </div>
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
